// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { ListChecks as RawListChecks } from "lucide-react";
export const ListChecks = /* @__PURE__ */ createIcon(RawListChecks, "ListChecks", 2);
